<div class="back-button-container">
    <div id="back-button" (click)="handleClick()">
        <mat-icon>arrow_back</mat-icon>
    </div>
    <a class="overflow">
        {{title}}
    </a>
</div>